import Page from './../Page'
import BlogPost from './../BlogPost'
import Row from './../Row'
import Teaser from './../Teaser'
import Features from './../Features'
import FeatureItem from './../FeatureItem'
import Testimonials from './../Testimonials'
import TestimonialItem from './../TestimonialItem'
import NavigationItem from './../NavigationItem'
import Logos from './../Logos'
import LogoItem from './../LogoItem'
import ComponentNotFound from './../ComponentNotFound'
import Copy from './../Copy'
import Newsletter from './../Newsletter'
import Banner from './../Banner'
import Button from './../Button'
import Steps from './../Steps'
import StepItem from './../StepItem'
import GetInvolved from './../GetInvolved'
import Quote from './../Quote'
import TeamGrid from './../TeamGrid'
import TeamCarousel from './../TeamCarousel'
import Spacer from './../Spacer'
import Usps from './../Usps'
import ProductInformation from './../ProductInformation'
import ProductCarousel from './../ProductCarousel'
import Facts from './../Facts'
import NumbersCarousel from './../NumbersCarousel'
import BlogCarousel from './../BlogCarousel'
import ImageComponent from './../ImageComponent'
import TitleWithButton from './../TitleWithButton'
import Downloads from './../Downloads'
import CustomMap from './../CustomMap'
import Grid from './../Grid'
import TextWithImage from './../TextWithImage'
import Charts from './../Charts'
import EmbeddedContent from './../EmbeddedContent'
import CareerGrid from './../CareerGrid'
import BlogGrid from './../BlogGrid'

const ComponentList = {
	page: Page,
	blogpost: BlogPost,
	row: Row,
	copy: Copy,
	button: Button,
	teaser: Teaser,
	features: Features,
	feature_item: FeatureItem,
	testimonials: Testimonials,
	testimonial_item: TestimonialItem,
	steps: Steps, 
	step_item: StepItem,
	logos: Logos,
	logo_item: LogoItem,
	nav_item: NavigationItem,
	newsletter: Newsletter,
	banner: Banner,
	get_involved: GetInvolved,
	quote: Quote,
	team_grid: TeamGrid,
	team_carousel: TeamCarousel,
	spacer: Spacer,
	usps: Usps,
	product_information: ProductInformation,
	product_carousel: ProductCarousel,
	facts: Facts,
	numbers_carousel: NumbersCarousel,
	blog_carousel: BlogCarousel,
	image: ImageComponent,
	title_with_button: TitleWithButton,
	downloads: Downloads,
	map: CustomMap,
	grid: Grid,
	text_with_image: TextWithImage,
	charts: Charts,
	embedded_content: EmbeddedContent,
	career_grid: CareerGrid,
	blog_grid: BlogGrid
}

const Components = (type) => {
	if (typeof ComponentList[type] === 'undefined') {
		return ComponentNotFound
	}
	
	return ComponentList[type]
}

export default Components